'use client'

import React from 'react'
import classNames from 'classnames'
import styles from './Typography.module.css'
import { BaseTypographyProps, ResponsiveProps, createCombinedStyles } from './typographyUtils'

export type ParagraphVariant = 'regular-26' | 'regular-22' | 'regular-18' | 'regular-16' | 'regular-14'

export interface ParagraphProps extends BaseTypographyProps {
  variant?: ParagraphVariant
  as?: 'p' | 'div' | 'span' | 'h5' | 'h6'
  responsive?: ResponsiveProps
}

export const Paragraph = ({
  children,
  variant = 'regular-18',
  as: Component = 'p',
  className = '',
  color,
  responsive,
  style = {},
  ...props
}: ParagraphProps) => {
  // Create combined styles using the utility function
  const combinedStyles = createCombinedStyles(style, color, responsive)

  // Use classNames to combine classes
  const combinedClassNames = classNames(styles[variant], className)

  return (
    <Component className={combinedClassNames} style={combinedStyles} {...props}>
      {children}
    </Component>
  )
}

export default Paragraph
